import * as Sentry from "@sentry/browser";

import { type CompanyAddressStoreBase } from "services/companyAddress/companyAddressStoreBase";
import { type DirectorStore } from "services/director/directorStore";
import { type ProfileStore } from "services/profile/profileStore";
import { type ScaSignupClient } from "./scaSignupClient";
import { ScaSignupData } from "./scaSignupTypes";

export class ScaSignupStore {
  constructor(
    private readonly _scaSignupClient: ScaSignupClient,
    private readonly _directorStore: DirectorStore,
    private readonly _companyAddressStore: CompanyAddressStoreBase,
    private readonly _profileStore: ProfileStore,
  ) {}

  // Fire-and-forget: an SCA signup failure must never block the formation submission
  async trySignup(): Promise<void> {
    try {
      const director = this._directorStore.mainDirector;
      if (!director) {
        return;
      }
      const address = this._companyAddressStore.address;
      const data = new ScaSignupData({
        firstName: director.firstName ?? "",
        middleName: director.middleNames ?? "",
        lastName: director.lastName ?? "",
        email: director.email ?? this._profileStore.profile.email,
        dateOfBirth: director.dob ?? "",
        country: address?.country ?? "",
        postcode: address?.postcode ?? "",
        state: address?.county ?? "",
        suburb: address?.town ?? "",
        streetType: "",
        streetName: address?.street ?? "",
        streetNumber: "",
        unit: address?.premise ?? "",
      });
      await this._scaSignupClient.signup(data);
    } catch (e) {
      Sentry.captureException(e);
    }
  }
}
